import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import AOS from "aos";
import "aos/dist/aos.css";
import ApiPath from "../Common/Apiurl";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

const FooterNew = () => {
  const [formVisible, setFormVisible] = useState(true);
  const [formMessage, setFormMessage] = useState(null);
  const [messageColor, setMessageColor] = useState("text-black");

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
  }, []);

  const handleClick = () => {
    if (location.pathname === "/" || location.pathname === "/contact") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const handleNavLinkClick = (path) => {
    if (path === "/careers/work-with-us/#history") {
      path = "/careers/work-with-us/";
    }

    if (location.pathname === path) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      navigate(path);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await fetch(ApiPath + "/newsletter", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: values.email,
          }),
        });

        if (response.ok) {
          const data = await response.json();

          if (data.STATUSCode === 200) {
            setMessageColor("text-green-500");
            setFormMessage("Thank you for subscription");
            setFormVisible(false);
            resetForm();
          } else {
            setMessageColor("text-red-500");
            setFormMessage("Something went wrong");
          }
        }
      } catch (error) {
        console.error(error);
        setMessageColor("text-red-500");
        setFormMessage("Something went wrong");
      }
    },
  });

  return (
    <>
      {/* MAIN FOOTER */}
      <footer className="w-full overflow-x-hidden">
        {/* TOP SECTION */}
        <div className="bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
              {/* LEFT SECTION */}
              <div>
                <Link to={location.pathname === "/" ? "#" : "/"}>
                  <img
                    src="/assets/images/envelop.png"
                    alt="ThinkQuotient"
                    className="h-12 sm:h-14 mb-6 cursor-pointer"
                    onClick={handleClick}
                  />
                </Link>

                <p className="text-gray-700 leading-7 max-w-xl">
                  Transform your business with AI automation, intelligent
                  workflows, and scalable digital solutions built for modern
                  enterprises.
                </p>

                {/* SOCIAL ICONS */}
                <div className="flex flex-wrap gap-4 mt-6">
                  {/* <a
                    href="https://www.instagram.com/thinkquotient_software/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaInstagram className="text-2xl hover:text-blue-500 transition" />
                  </a>

                  <a
                    href="https://www.linkedin.com/company/thinkquotient?originalSubdomain=in"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaLinkedinIn className="text-2xl hover:text-blue-500 transition" />
                  </a>

                  <a
                    href="https://www.youtube.com/@thinkquotient1429"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaYoutube className="text-2xl hover:text-blue-500 transition" />
                  </a> */}

                  <a
                    href="https://www.facebook.com/profile.php?id=61589595790421"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaFacebookF className="text-xl hover:text-blue-500 transition" />
                  </a>
                </div>
              </div>

              {/* CENTER SECTION - RESOURCES */}
              <div >
                <h2 className="text-xl font-semibold mb-6">Resources</h2>

                <ul className="space-y-3 text-gray-700">
                  <li>
                    <Link
                      to="/"
                      className="hover:text-blue-500 transition"
                      onClick={handleClick}
                    >
                      Home
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/about-us"
                      className="hover:text-blue-500 transition"
                    >
                      About Us
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/privacy-policy"
                      className="hover:text-blue-500 transition"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>

              {/* RIGHT SECTION */}
              <div>
                <h2 className="text-xl font-semibold mb-6">Contact Us</h2>

                <div className="space-y-4 text-gray-700">
                  <div>
                    <span className="font-semibold">Phone: </span>
                    <a
                      href="tel:+917030055128"
                      className="hover:text-blue-500 transition"
                    >
                      +91-7030055128
                    </a>
                  </div>

                  <div>
                    <span className="font-semibold">Email: </span>
                    <a
                      href="mailto:enquiry@thinkquotient.ai"
                      className="hover:text-blue-500 transition break-all"
                    >
                      enquiry@thinkquotient.ai
                    </a>
                  </div>

                  <div>
                    <span className="font-semibold">Address: </span>
                    <a
                      href="https://www.google.com/maps/place/ThinkQuotient+Software+Private+Limited/@18.49033,73.8496076,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2c01b4c092d2d:0x7c010136a378ae2a!8m2!3d18.490325!4d73.854221!16s%2Fg%2F11bx1hq4rt?entry=ttu&g_ep=EgoyMDI2MDQyMi4wIKXMDSoASAFQAw%3D%3D"
                      target="_blank"
                      rel="noreferrer"
                      className="hover:text-blue-500 transition text-sm leading-7 block mt-2"
                    >
                      Shree Chaitanya Apartment, A/09, Shiv Darshan Rd, near
                      Muktangan English School & Junior College, Vrindavan
                      Society, Sivadarshan Poorgrasta Vasahat, Parvati, Pune,
                      Maharashtra 411009
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM FOOTER */}
        <div className="bg-black text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center">
            <p className="text-sm sm:text-base leading-7">
              © Copyright 2026 by{" "}
              <Link to={location.pathname === "/" ? "#" : "/"}>
                <span
                  onClick={handleClick}
                  className="font-semibold cursor-pointer hover:text-blue-400"
                >
                  ThinkQuotient
                </span>
              </Link>
              . Any assurances made by the Company shall not be construed as
              Guarantee and past record is no guarantee of future prospects.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterNew;
